import { render, staticRenderFns } from "./restricciones-recomendaciones-editar.vue?vue&type=template&id=02d5c6ca&scoped=true&"
import script from "./restricciones-recomendaciones-editar.vue?vue&type=script&lang=js&"
export * from "./restricciones-recomendaciones-editar.vue?vue&type=script&lang=js&"
import style0 from "./restricciones-recomendaciones-editar.vue?vue&type=style&index=0&id=02d5c6ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d5c6ca",
  null
  
)

export default component.exports